import { render, staticRenderFns } from "./ProjectListProjectLead.vue?vue&type=template&id=f354462a&"
import script from "./ProjectListProjectLead.vue?vue&type=script&lang=js&"
export * from "./ProjectListProjectLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f354462a')) {
      api.createRecord('f354462a', component.options)
    } else {
      api.reload('f354462a', component.options)
    }
    module.hot.accept("./ProjectListProjectLead.vue?vue&type=template&id=f354462a&", function () {
      api.rerender('f354462a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectListProjectLead.vue"
export default component.exports